export default "__VITE_ASSET__8BOVnR2G__"